(ns frontend.ui.component.lp-portal.report.body.invest-europe.holding.pdf.holding
  (:require
   [common.util :as cu]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.report.component.overview-figures.pdf-view :as overview-figures-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer
    [empty-chart-data?]]))

(defn- investment-info-figures
  [{:keys [investment-info]}]
  (block-table-pdf/table investment-info))

(defn revenue-chart
  [data]
  (let [figures (-> data
                    :revenue
                    :figures)]
    (when-not (empty-chart-data? data :revenue)
      [(card/card
        "Revenue"
        {:svg    (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge figures
                                                           {:chart {:width     450
                                                                    :height    300
                                                                    :spacing   [10 0 0 0]
                                                                    :marginTop 20}
                                                            :legend {:verticalAlign "top"
                                                                     :align         "center"
                                                                     :floating      true
                                                                     :padding       0}}))
         :width  250
         :height 150}
        (text-content/optional-footer (:revenue data)))])))

(defn headcount-chart
  [data]
  (let [figures (-> data
                    :headcount
                    :figures)]
    (when-not (empty-chart-data? data :headcount)
      [(card/card
        "Headcount"
        {:svg    (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge figures
                                                           {:chart {:width     450
                                                                    :height    300
                                                                    :spacing   [10 0 0 0]
                                                                    :marginTop 20}
                                                            :legend {:verticalAlign "top"
                                                                     :align         "center"
                                                                     :floating      true
                                                                     :padding       0}}))
         :width  250
         :height 150}
        (text-content/optional-footer (:headcount data)))])))
(defn on-track-company-page-1
  [data]
  (let [{:keys [overview highlight-figures holding-name]} data]
    (page/page
     (page/third-column-background-full-height-not-rounded)
     (page/page-title-with-line {:page-title holding-name :toc-item true})
     (column/columns-2-to-1
      (card/card
       nil
       (card/card
        ""
        (text-content/rich-content (->> overview
                                        :case-overview
                                        :rich-content))
        (column/columns
         (revenue-chart data)
         (headcount-chart data))))
      (card/card
       nil
       (investment-info-figures overview)
       (text-content/optional-footer (:investment-info overview))
       (overview-figures-pdf/table (:figures highlight-figures) 2)
       (text-content/optional-footer highlight-figures))))))


(defn holding-pages
  [data]
  (when-not (cu/blank-value? (:reference-date data))
    (concat
     [(on-track-company-page-1 data)])))
